export const CREATE_LOAN = "CREATE_LOAN";
export const FETCH_LOANS = "FETCH_LOANS";
export const FETCH_LOAN = "FETCH_LOAN";
export const EDIT_LOAN = "EDIT_LOAN";
export const DELETE_LOAN = "DELETE_LOAN";
